import React, { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const InputDragDrop = () => {
  const [files, setFiles] = useState([]);

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    console.log({ result });
    const items = Array.from(files);
    const [reorderedFile] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedFile);

    setFiles(items);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles([...files, ...droppedFiles]);
  };
  const handleDrag = (e) => {
    e.preventDefault();
    console.log({ e });
  };
  const handleFileInputChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles([...files, ...selectedFiles]);
  };
  return (
    <div>
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <Droppable droppableId="files">
          {(provided) => (
            <ul
              className="file-list"
              {...provided.droppableProps}
              ref={provided.innerRef}
              onDrop={handleDrop}
              onDragOver={(e) => handleDrag(e)}
            >
              {files.map((file, index) => (
                <Draggable
                  key={file.name}
                  draggableId={file.name}
                  index={index}
                >
                  {(provided) => (
                    <li
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className="file-item"
                    >
                      <img
                        src={URL.createObjectURL(file)}
                        alt={file.name}
                        className="file-preview"
                      />
                      <p>{file.name}</p>
                    </li>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </ul>
          )}
        </Droppable>
      </DragDropContext>

      <input
        type="file"
        multiple
        onChange={handleFileInputChange}
        style={{ marginTop: "20px" }}
      />
    </div>
  );
};

export default InputDragDrop;
